import { type PlainDate, formatPlainDate } from "@sa-nu/shared-utils/date";

/**
 * SiteDetailRoomsHeader の日程・泊数表示。開始日は年込み、終了日（CO日 = lastNight + 1）は
 * 年を省略する Figma 仕様（node-id 7208:44469）に合わせる。
 */
export function formatRoomsHeaderDateRange(
  firstNight: PlainDate,
  lastNight: PlainDate,
): string {
  const checkoutDate = lastNight.add({ days: 1 });
  const nights = firstNight.until(checkoutDate).total({ unit: "day" });
  const startLabel = formatPlainDate(firstNight, {
    format: "slash",
    pad: true,
  });
  const endLabel = formatPlainDate(checkoutDate, {
    format: "slash",
    pad: true,
    excludeYear: true,
  });
  return `${startLabel} - ${endLabel} ${nights}泊`;
}
